import ScenesColumn from "./components/tableColumn/ScenesColumn";
import AnswerColumn from "./components/tableColumn/AnswerColumn";
import OperateColumn from "./components/tableColumn/OperateColumn";
import UserQuesColumn from "./components/tableColumn/UserQuesColumn";
import StandQuestionColumn from "./components/tableColumn/StandQuestionColumn";

import i18n from "@/i18n";

export const askLogTable = () => {
    return {
        columns: [
            {
                colId: "time",
                header: i18n.t("zhiji.robotLog.tabelCloumn.messageTime"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "sessionId",
                header: i18n.t("zhiji.robotLog.tabelCloumn.sessionId"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "accountId",
                header: i18n.t("zhiji.robotLog.tabelCloumn.accountId"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "questionType",
                header: i18n.t("zhiji.robotLog.tabelCloumn.questionType"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "userQuestion",
                header: i18n.t("zhiji.robotLog.tabelCloumn.quesContent"),
                type: "Custom",
                width: "8%",
                component: UserQuesColumn
            },
            {
                colId: "sensitiveWord",
                header: i18n.t("zhiji.sensitiveWord.sensitiveWord"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "scenes",
                header: i18n.t("zhiji.robotLog.tabelCloumn.scenes"),
                type: "Custom",
                width: "8%",
                component: ScenesColumn
            },
            {
                colId: "standQuestion",
                header: i18n.t("zhiji.robotLog.tabelCloumn.standQuestion"),
                type: "Custom",
                width: "10%",
                component: StandQuestionColumn
            },
            {
                colId: "questionId",
                header: i18n.t("zhiji.robotLog.tabelCloumn.questionId"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "answer",
                header: i18n.t("zhiji.robotLog.tabelCloumn.answerContent"),
                type: "Custom",
                width: "16%",
                component: AnswerColumn
            },
            {
                colId: "operate",
                header: i18n.t("zhiji.common.operate"),
                type: "Custom",
                width: "",
                component: OperateColumn
            }
        ],
        isHideFooter: true,
        pageLength: 10
    };
};

export const answerOptions = () => [
    {
        label: i18n.t("zhiji.robotLog.allAnswer"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.robotLog.noAnswer"),
        value: "noAnswer"
    },
    {
        label: i18n.t("zhiji.robotLog.answered"),
        value: "hasAnswer"
    }
];

export const questionOptions = () => [
    {
        label: i18n.t("zhiji.robotLog.selectType"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.robotLog.byUesr"),
        value: "user"
    },
    {
        label: i18n.t("zhiji.robotLog.byScene"),
        value: "scenes"
    },
    {
        label: i18n.t("zhiji.robotLog.byQuestion"),
        value: "stand"
    },
    {
        label: i18n.t("zhiji.robotLog.byQuestionId"),
        value: "questionId"
    },
    {
        label: i18n.t("zhiji.robotLog.byChatId"),
        value: "chatId"
    }
];

export const senistiveWordOptions = () => [
    {
        label: i18n.t("zhiji.robotLog.hasSenisitive"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.robotLog.yes"),
        value: "yes"
    },
    {
        label: i18n.t("zhiji.robotLog.no"),
        value: "no"
    }
];
